import React from "react"

import ReactTable from "react-table"

import { APIPost, APIGet } from "services/APIRequest"
import ConfigHost from "services/ConfigHost"

import { arrayObject } from "ConvertKey"
import UrlServer from "configs/UrlServer"
import Auth from "auth"
import { ErrorsCallback, SuccessCallback, WarningCallback } from "alertService"

import { compose } from "recompose"
import { connect } from "react-redux"

import { ISOToDateFormat } from "helpers/ConvertDate"
import { thaiBath } from "helpers/ConvertFormat"
import Datetime from "react-datetime";
import { replaceNumberQuestion } from "helpers/ConvertString"

import * as Alert from "alertService"

import Lng from "language"
import wordingQuestion from "configs/wordingQuestion.jsx"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

// @material-ui/icons
import ViewListIcon from '@material-ui/icons/ViewList';
import CloudDownloadIcon from "@material-ui/icons/CloudDownload"
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import SearchIcon from "@material-ui/icons/Search";
import AddCircleIcon from '@material-ui/icons/AddCircle';

// @material-ui/Dialog 
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

// core components

import { green } from '@material-ui/core/colors';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import Favorite from '@material-ui/icons/Favorite';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';

import EventNoteIcons from "@material-ui/icons/EventNote"

import GridContainer from "components/Grid/GridContainer.jsx"
import GridItem from "components/Grid/GridItem.jsx"
import CustomInput from "components/CustomInput/CustomInput.jsx"
import Button from "components/CustomButtons/Button.jsx"
import Card from "components/Card/Card.jsx"
import CardBody from "components/Card/CardBody.jsx"
import CardIcon from "components/Card/CardIcon.jsx"
import CardHeader from "components/Card/CardHeader.jsx"
import Select from "components/CustomSelects/Select.jsx"
import Autocomplete from "components/Autocomplete/Select.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx"
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle"
import FormLabel from "@material-ui/core/FormLabel"
import { colors } from "@material-ui/core"

import flag_TH from "assets/img/flags/TH.png";
import flag_EN from "assets/img/flags/GB.png";
import flag_JP from "assets/img/flags/JP.png";
import flag_CN from "assets/img/flags/CN.png";

const styles = {
  ...regularFormsStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  marginHR: {
    marginTop: "35px",
    marginBottom: "-5px"
  },
  mt4: {
    marginTop: "15px"
  }
}
const GreenCheckbox = withStyles({
  root: {
    color: green[400],
    '&$checked': {
      color: green[600],
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

var userCode = Auth.getUserData()

class ReportQuarterPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      original_id: null,
      original_txt: "",

      lng_th: true,
      lng_th_txt: "",
      lng_en: true,
      lng_en_txt: "",
      lng_jp: true,
      lng_jp_txt: "",
      lng_cn: true,
      lng_cn_txt: "",

      list_language_raw: [],
      list_language: [],
      current_index_list: null,
    }
  }
  componentDidMount() {
    this.loadLanguage(() => {
      this.loadTranslateData(() => {

      })
    })
  }

  loadTranslateData = (callback) => {

    APIPost(UrlServer.URL_GET_LANGUAGE_GET_TRANSLATE_DATA, {}, ({ datas }) => {

      this.setState({
        list_language_raw: datas,
        list_language: this.renderListData(datas),
      }, () => {
        callback()
      });
    })
  }
  loadLanguage = (callback) => {
    APIPost(UrlServer.URL_GET_LANGUAGE_GET_ALLOW_LANGUAGE, {}, ({ datas }) => {
      var lng_th = true
      var lng_en = true
      var lng_jp = true
      var lng_cn = true

      if (datas && datas.length > 0) {
        datas.map((row) => {
          switch (row.key) {
            case "TH":
              lng_th = row.active
              break;
            case "EN":
              lng_en = row.active
              break;
            case "JP":
              lng_jp = row.active
              break;
            case "CN":
              lng_cn = row.active
              break;
          }
        })
      }
      this.setState({
        lng_th: lng_th,
        lng_en: lng_en,
        lng_jp: lng_jp,
        lng_cn: lng_cn,
      }, () => {
        callback()
      });
    })
  }
  handleViewDetail = (index, data) => {
    this.setState({
      original_id: data._id,
      original_txt: data.original_txt,
      lng_th_txt: data.lng_th_txt,
      lng_en_txt: data.lng_en_txt,
      lng_jp_txt: data.lng_jp_txt,
      lng_cn_txt: data.lng_cn_txt,
    })
  }
  renderListData = data => {
    return data.map((row, key) => {
      return {
        no: (key + 1),
        original_txt: row.original_txt,
        lng_th_txt: row.lng_th_txt || " ",
        lng_en_txt: row.lng_en_txt || " ",
        lng_jp_txt: row.lng_jp_txt || " ",
        lng_cn_txt: row.lng_cn_txt || " ",
        actions: (
          <div className="actions-right">
            <Button
              size="sm"
              round
              onClick={() => this.handleViewDetail(key, row)}
              color="warning"
              className="remove"
            >
              <EventNoteIcons />แก้
            </Button>{" "}
          </div>
        )
      }
    })
  }

  handleChange = (name, val) => {

    this.setState({
      [name]: val
    })
  }
  handleChangeState = name => event => {
    this.setState({
      [name]: event.target.value
    })
  }

  handleChangeAutoComplete = name => value => {
    this.setState({
      [name]: value,
    }, () => {

    });
  };

  handleChangeCheckbox = e => {
    var name = e.target.name
    this.setState({ [name]: !this.state[name] }, () => {
      var _key = ""
      switch (name) {
        case "lng_th":
          _key = "TH"
          break;
        case "lng_en":
          _key = "EN"
          break;
        case "lng_jp":
          _key = "JP"
          break;
        case "lng_cn":
          _key = "CN"
          break;
      }
      var _status = this.state[name]
      APIPost(UrlServer.URL_GET_LANGUAGE_UPDATE_ALLOW_LANGUAGE, {
        key: _key,
        active: _status
      }, ({ datas }) => {

      })
    })
  }
  handleAddLanguage = () => {
    this.setState({
      original_id: null,
      original_txt: "",
      lng_th_txt: "",
      lng_en_txt: "",
      lng_jp_txt: "",
      lng_cn_txt: "",
    }, () => {

    })
  }
  handleSave = () => {
    if (!this.state.original_txt) {
      Alert.WarningCallback("โปรดใส่คำที่ต้องการแปล!")
      return
    }
    APIPost(UrlServer.URL_GET_LANGUAGE_CREATE_TRANSLATE, {
      original_txt: this.state.original_txt,
      lng_th_txt: this.state.lng_th_txt == "" ? undefined : this.state.lng_th_txt,
      lng_en_txt: this.state.lng_en_txt == "" ? undefined : this.state.lng_en_txt,
      lng_jp_txt: this.state.lng_jp_txt == "" ? undefined : this.state.lng_jp_txt,
      lng_cn_txt: this.state.lng_cn_txt == "" ? undefined : this.state.lng_cn_txt
    }, ({ datas }) => {

      this.setState({
        original_id: null,
        original_txt: "",
        lng_th_txt: "",
        lng_en_txt: "",
        lng_jp_txt: "",
        lng_cn_txt: "",
      }, () => {
        this.loadTranslateData(() => {
          if (datas.nModified == 1) {
            Alert.SuccessCallback("แก้ไขคำแปลเดิมที่มีอยู่แล้วเรียบร้อย")
          } else if (datas.n == 1) {
            Alert.SuccessCallback("สร้างคำแปลใหม่เรียบร้อย")
          }
          var obj = {}
          this.state.list_language_raw.map((row) => {
            obj[row.original_txt.toLowerCase()] = row
          })
          Lng.setTranslate(obj)
        })
      })

    })
  }
  render() {
    const { classes } = this.props
    const userData = Auth.getUserData()
    return (
      <div className={"card-space"} >
        <GridContainer >
          <GridItem xs={12}>
            <Card>
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <ViewListIcon />
                </CardIcon>
                {/* ออกรายงาน */}
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer justify="center" >
                    <GridItem xs={12} sm={12} >
                      <GridContainer>
                        <GridItem xs={3}>
                          <FormControlLabel
                            control={<Checkbox disabled checked={this.state.lng_th} onChange={this.handleChangeCheckbox} name="lng_th" />}
                            label={<span> <img src={flag_TH} alt="..." /> [ TH ] Thailand</span>}
                          />
                        </GridItem>
                        <GridItem xs={3}>
                          <FormControlLabel
                            control={<GreenCheckbox checked={this.state.lng_en} onChange={this.handleChangeCheckbox} name="lng_en" />}
                            label={<span> <img src={flag_EN} alt="..." /> [ EN ] English</span>}
                          />
                        </GridItem>
                        <GridItem xs={3}>
                          <FormControlLabel
                            control={<GreenCheckbox checked={this.state.lng_jp} onChange={this.handleChangeCheckbox} name="lng_jp" />}
                            label={<span> <img src={flag_JP} alt="..." /> [ JP ] Jengapanese</span>}
                          />
                        </GridItem>
                        <GridItem xs={3}>
                          <FormControlLabel
                            control={<GreenCheckbox checked={this.state.lng_cn} onChange={this.handleChangeCheckbox} name="lng_cn" />}
                            label={<span> <img src={flag_CN} alt="..." /> [ CN ] China</span>}
                          />
                        </GridItem>

                        <GridItem xs={12} className={"autocomplete-space"}>
                          <hr className="hr-1" />
                        </GridItem>
                      </GridContainer>
                      <GridContainer className={classes.mt4}>
                        <GridItem xs={7} >

                          <Button
                            size="sm"
                            fullWidth
                            round
                            color="info"
                            onClick={e => this.handleAddLanguage()}
                          >
                            <AddCircleIcon className={classes.icons} />
                            {Lng.ts("add_word")}
                          </Button>
                          <div className={"chart-box"}>
                            <center>
                              <div id="chart_1_1" style={{ width: "92%", height: "470px" }}>
                                <ReactTable
                                  data={this.state.list_language}
                                  filterable
                                  columns={[
                                    {
                                      Header: "No.",
                                      accessor: "no",
                                      width: 70
                                    },
                                    {
                                      Header: "Action",
                                      accessor: "actions",
                                      sortable: false,
                                      filterable: false
                                    },
                                    {
                                      Header: "Wording",
                                      accessor: "original_txt",
                                      filterMethod: (filter, row) => {
                                        return row.original_txt.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                      }
                                    },
                                    {
                                      Header: "TH",
                                      accessor: "lng_th_txt",
                                      filterMethod: (filter, row) => {
                                        return row.lng_th_txt.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                      }
                                    },
                                    {
                                      Header: "EN",
                                      accessor: "lng_en_txt",
                                      filterMethod: (filter, row) => {
                                        return row.lng_en_txt.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                      }
                                    },
                                    {
                                      Header: "JP",
                                      accessor: "lng_jp_txt",
                                      filterMethod: (filter, row) => {
                                        return row.lng_jp_txt.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                      }
                                    },
                                    {
                                      Header: "CN",
                                      accessor: "lng_cn_txt",
                                      filterMethod: (filter, row) => {
                                        return row.lng_cn_txt.toLowerCase().indexOf(filter.value.toLowerCase()) >= 0;
                                      }
                                    },
                                    {
                                      Header: ".",
                                      accessor: ".",
                                      sortable: false,
                                      filterable: false,
                                      width: 10
                                    }

                                  ]}
                                  defaultPageSize={5}
                                  showPaginationTop
                                  showPaginationBottom={false}
                                  className="-striped -highlight"
                                />
                              </div>
                            </center>
                          </div>
                        </GridItem>
                        <GridItem xs={5}>
                          <GridContainer>
                            <GridItem xs={12} >
                              <small className="txt-c-dorg2">
                                คำที่สามารถใช้ function แปลภาษาได้จะต้องมี "[org]"" นำหน้า เช่น "[org]add_word" เมื่อเราใส่คำแปลที่ TH เป็น "เพิ่มคำ" ผลการแสดงจาก "[org]add_word" จะกลายเป็น "เพิ่มคำ"
                              </small>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={2} lg={2}>
                              <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                                Keyword
                              </FormLabel>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={10} lg={10}>
                              <CustomInput
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  // disabled: ((this.state._id) ? true : false),
                                  type: "text",
                                  value: this.state.original_txt,
                                  placeholder: "Original Wording",
                                  onChange: this.handleChangeState("original_txt")
                                }}
                                helpText={(<span className="txt-c-b1">ใส่คำใหม่ที่ต้องการแปล ถ้ามีคำอยู่แล้วระบบจะทำการอัปเดทคำเดิม</span>)}
                              // helpText={((this.state.original_id) ? "ID Original : " + this.state.original_id : (<span className="txt-c-r">* ใส่คำใหม่ที่ต้องการแปล </span>))}
                              />
                            </GridItem>
                          </GridContainer>
                          <hr className="hr-1" />
                          <GridContainer className="p-s-1">
                            <GridItem xs={12} sm={12} md={2} lg={2}>
                              <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                                Thailand
                              </FormLabel>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={10} lg={10}>
                              <CustomInput
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  disabled: ((this.state._id) ? true : false),
                                  type: "text",
                                  value: this.state.lng_th_txt,
                                  placeholder: "Thailand Wording",
                                  onChange: this.handleChangeState("lng_th_txt")
                                }}
                                helpText={<small className="txt-c-dorg2">ถ้าไม่ใส่คำ จะถูกแสดง Original Wording แทน</small>}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer className="p-s-1">
                            <GridItem xs={12} sm={12} md={2} lg={2}>
                              <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                                English
                              </FormLabel>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={10} lg={10}>
                              <CustomInput
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  disabled: ((this.state._id) ? true : false),
                                  type: "text",
                                  value: this.state.lng_en_txt,
                                  placeholder: "English Wording",
                                  onChange: this.handleChangeState("lng_en_txt")
                                }}
                                helpText={<small className="txt-c-dorg2">ถ้าไม่ใส่คำ จะถูกแสดง Original Wording แทน</small>}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer className="p-s-1">
                            <GridItem xs={12} sm={12} md={2} lg={2}>
                              <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                                Jengapanese
                              </FormLabel>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={10} lg={10}>
                              <CustomInput
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  disabled: ((this.state._id) ? true : false),
                                  type: "text",
                                  value: this.state.lng_jp_txt,
                                  placeholder: "Jengapanese Wording",
                                  onChange: this.handleChangeState("lng_jp_txt")
                                }}
                                helpText={<small className="txt-c-dorg2">ถ้าไม่ใส่คำ จะถูกแสดง Original Wording แทน</small>}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer className="p-s-1">
                            <GridItem xs={12} sm={12} md={2} lg={2}>
                              <FormLabel className={classes.labelHorizontal + " txt-c-b2"}>
                                China
                              </FormLabel>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={10} lg={10}>
                              <CustomInput
                                formControlProps={{
                                  fullWidth: true
                                }}
                                inputProps={{
                                  disabled: ((this.state._id) ? true : false),
                                  type: "text",
                                  value: this.state.lng_cn_txt,
                                  placeholder: "China Wording",
                                  onChange: this.handleChangeState("lng_cn_txt")
                                }}
                                helpText={<small className="txt-c-dorg2">ถ้าไม่ใส่คำ จะถูกแสดง Original Wording แทน</small>}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12}>
                              <br />
                              <hr className="hr-1" />
                              <Button
                                size="sm"
                                fullWidth
                                round
                                color="success"
                                onClick={e => this.handleSave()}
                              >
                                <CloudUploadIcon className={classes.icons} />
                                บันทึก
                              </Button>
                            </GridItem>
                          </GridContainer>
                          {
                            // <Button
                            //   fullWidth
                            //   round
                            //   color="info"
                            //   onClick={this.handleDownloadExcelFile}
                            // >
                            //   <CloudDownloadIcon className={classes.icons} />
                            //   ดาวน์โหลด Report Excel
                            // </Button>
                          }

                        </GridItem>
                      </GridContainer>
                    </GridItem>
                  </GridContainer>
                </form>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

export default withStyles(styles)(ReportQuarterPage)
